/**
 * 首页
 * 2017-12-6
 */
"use strict";
angular.module("registerModule", [
	"registerRouter", //路由
	"agreementServiceModule", //协议
	"basicInformationModule", //基本信息
	"authenticationModule", //认证信息
	"pgcAuthenticationModule", //pgc认证信息
	"successModule", //成功
	"pgcSuccessModule", //pgc成功
	"successEnterpriseModule", //pgc企业
]).
controller("registerCtrl", ["$scope", "httpService", '$filter', 'agreementService', function($scope, httpService, $filter, agreementService) {
	initStatus();
	initData();
	/**
	 * [initStatus description] 初始化参数
	 */
	function initStatus() {
		$scope.status = {
			platformName: '',
			ifshowPGC:false,
		};
	}
	/**
	 * [initStatus description] 初始化数据
	 */
	function initData() {
		requestData();
	}

	/**
	 * [dateFormat description] 时间格式化
	 * @return {[type]} [description]
	 */
	$scope.dateFormat = function(item) {
		item.newTime = $filter("date")(item.pubTime, "yyyy-MM-dd HH:mm:ss").toString();
	};

	/**
	 * [createProduct description] -协议
	 * @return {[type]} [description]
	 */
	$scope.agreement = function(item) {
		$scope.status.chose = item;
		agreementService.agreement($scope.status).then(function(data) {

		});
	};

	function requestData() {
		httpService.http("/mcnww/web/tenant/getSecondDomain.do", '', "post").then(function(data) {
			$scope.status.platformName = data.data.platformName || '新疆吉木萨尔县';
			$scope.status.ifshowPGC = data.isSupportPgc;
		});
	}
}]);